package team.platforma.chat_presentation

import androidx.lifecycle.ViewModel
import com.platforma.chat_domain.ChatsUseCase
import com.platforma.chat_domain.DraftUseCase
import com.platforma.chat_domain.MessagesUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.chat_presentation.model.Chat
import team.platforma.chat_presentation.model.DraftPresentation
import team.platforma.chat_presentation.model.MessagePresentation

class ChatViewModel(
    private val draftUseCase: DraftUseCase,
    private val messagesUseCase: MessagesUseCase,
    private val chatsUseCase: ChatsUseCase
) : ViewModel() {

    private val singletonScope = CoroutineScope(Dispatchers.Default + SupervisorJob())

    private val _aiModelId = MutableStateFlow<Long?>(null)
    private val _chatId = MutableStateFlow(0L)
    private val _userId = MutableStateFlow(0L)

    val chatId: StateFlow<Long> = _chatId
    val aiModelId: StateFlow<Long> = _aiModelId.map { it ?: 0L }.stateIn(
        scope = singletonScope,
        started = SharingStarted.Eagerly,
        initialValue = 0L
    )


//    val draftList: StateFlow<List<DraftPresentation>> = draftUseCase.table.observeDrafts(aiModelId, chatId)

//    val draftList: StateFlow<List<DraftPresentation>> =
//        draftUseCase.table.observeDrafts(aiModelId, userId ,chatId)
//            .map { list -> list.map {
//                DraftPresentation(
//                    draftId = it.draftId,
//                    aiModelId = it.aiModelId,
//                    chatId = it.chatId,
//                    userId = it.userId,
//                    draftText = it.draftText,
//                    timeStamp = it.timeStamp
//                )
//            } } // или mapEachDraft(...)
//            .stateIn(
//                scope = singletonScope,
//                started = SharingStarted.Eagerly,
//                initialValue = emptyList()
//            )


    @OptIn(ExperimentalCoroutinesApi::class)
    private val draftList: Flow<List<DraftPresentation>> =
        combine(_aiModelId, _userId, _chatId) { modelId, userId, chatId ->
            Triple(modelId, userId, chatId)
        }.flatMapLatest { (modelId, userId, chatId) ->
            draftUseCase.table.observeDrafts(modelId, userId, chatId)
        }.map { list ->
            list.map {
                DraftPresentation(
                    draftId = it.draftId,
                    aiModelId = it.aiModelId,
                    userId = it.userId,
                    chatId = it.chatId,
                    text = it.text
                )
            }
        }


    fun setUserId(long: Long?) {
        _userId.value = long ?: 0
    }

    fun setAiModelId(long: Long?) {
        _aiModelId.value = long
    }

    fun setChatId(long: Long?) {
        _chatId.value = long ?: 0
    }

    private val _mutableDraft: MutableStateFlow<DraftPresentation> =
        MutableStateFlow(DraftPresentation(0, 0, 0, 0, ""))

    val draft: StateFlow<DraftPresentation> = _mutableDraft

    init {
        singletonScope.launch {
            draftList.collect { list ->
                if (list.isEmpty()) {
                    _aiModelId.value?.let { id ->
                        draftUseCase.table.createNewDraft(id, _userId.value, _chatId.value)
                    }
                } else {
                    _mutableDraft.value = list.last()
                }
            }
        }
    }

    fun updateDraftText(string: String) {
        println("new_text: $string")
        singletonScope.launch {
            draftUseCase.table.updateDraftText(
                draftId = _mutableDraft.value.draftId,
                chatId = _chatId.value,
                text = string
            )
        }
    }

    fun updateChat(chatID: Long) {
        val modelAi = _aiModelId.value
        _aiModelId.value = null
        _chatId.value = chatID
        _aiModelId.value = modelAi
    }


    @OptIn(ExperimentalCoroutinesApi::class)
    val messages: StateFlow<List<MessagePresentation>> =
        combine(_aiModelId, _chatId) { modelId, chatId ->
            modelId to chatId
        }.flatMapLatest { (modelId, chatId) ->
            messagesUseCase.table.observeMessages(modelId, chatId)
        }.map { list ->
            list.map {
                MessagePresentation(
                    text = it.text,
                    status = Status.valueOf(it.status.name),
                    senderId = it.senderId
                )
            }
        }.stateIn(
            scope = singletonScope,
            started = SharingStarted.Eagerly,
            initialValue = emptyList()
        )

    fun sendMessage(text: String) {
        singletonScope.launch {
            if (_chatId.value == 0L) {

                draftUseCase.table.updateDraftText(
                    draftId = _mutableDraft.value.draftId,
                    chatId = _chatId.value,
                    text = ""
                )
                // createNewChat
                messagesUseCase.network.createNewChat(
                    modelId = _aiModelId.value ?: 0L,
                    chatId = _chatId.value,
                    text = text
                ).onSuccess { chatId, code ->
//                    val oldModelId = _aiModelId.value
//                    try {
//                        _aiModelId.value = null
                        _chatId.value = chatId
                        draftUseCase.table.updateDraftText(
                            draftId = _mutableDraft.value.draftId,
                            chatId = chatId,
                            text = draft.value.text
                        )
//                    } finally {
//                        _aiModelId.value = oldModelId
//                    }
                }
            } else {

                draftUseCase.table.updateDraftText(
                    draftId = _mutableDraft.value.draftId,
                    chatId = _chatId.value,
                    text = ""
                )


                val aiContext = buildContextForAi(
                    messages = messages.value,
                    lastMessage = text,
                )

                messagesUseCase.network.sendActiveChatMessage(
                    modelId = _aiModelId.value ?: 0L,
                    chatId = _chatId.value,
                    userMessage = text,
                    aiContext = aiContext
                )
//                    .onSuccess { data, code ->
//                    messagesUseCase.table.updateMessage(
//                        chatId = data.chatId,
//                        tableMessageId = data.tableMessageId,
//                        status = MessageStatus.Delivered
//                    )
//                    draftUseCase.table.updateDraftText(
//                        draftId = _mutableDraft.value.draftId,
//                        chatId = data.chatId,
//                        text = draft.value.text
//                    )
//                }
            }
        }
    }

    fun buildContextForAi(
        messages: List<MessagePresentation>,
        lastMessage: String,
        maxLength: Int = 8000,
    ): String {

        val myId = getAccountManager().getUserId()

        val builder = StringBuilder()
        val lastMessageFormatted = "User: ${lastMessage}"
        var currentLength = lastMessageFormatted.length + 1 // +1 на перенос строки

       val reversed = messages.reversed()

        for (i in reversed.size - 1 downTo 0) {
            val msg = messages[i]
//            if (msg == lastMessage) continue // пропускаем последнее сообщение пользователя, оно внизу

            val role = if (msg.senderId == myId) "User" else "AI"
            val entry = "$role: ${msg.text}\n"
            if (currentLength + entry.length > maxLength) break

            builder.insert(0, entry)
            currentLength += entry.length
        }

        builder.append(lastMessageFormatted)

        return builder.toString()
    }

    fun stopGeneration() {
        singletonScope.launch {
            messagesUseCase.network.stopGeneration()
        }
    }

    @OptIn(ExperimentalCoroutinesApi::class)
    val chats: StateFlow<List<Chat>> =
        combine(_aiModelId, _userId) { modelId, userId ->
            modelId to userId
        }.flatMapLatest { (modelId, userId) ->
            chatsUseCase.table.observeAiChats(modelId, userId)
        }.map { list ->
            list.map {
                Chat(
                    id = it.id,
                    userId = it.userId,
                    aiModelId = it.aiModelId,
                    name = it.name
                )
            }
        }.stateIn(
            scope = singletonScope,
            started = SharingStarted.Eagerly,
            initialValue = emptyList()
        )


}